import React from 'react';

const LoadingSpinner = ({ size = 'md', color = 'blue' }) => {
  // Size classes
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-3',
    xl: 'h-16 w-16 border-4'
  };
  
  // Color classes
  const colorClasses = {
    blue: 'border-blue-600',
    white: 'border-white',
    gray: 'border-gray-600',
    green: 'border-green-600',
    red: 'border-red-600'
  };
  
  const sizeClass = sizeClasses[size] || sizeClasses.md;
  const colorClass = colorClasses[color] || colorClasses.blue;
  
  return (
    <div className={`animate-spin rounded-full ${sizeClass} border-t-transparent ${colorClass}`}></div>
  );
};

export default LoadingSpinner;